import { useState } from 'react';
import { createCheckout } from '../lib/api';

export function useCheckout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function checkout(email: string) {
    setLoading(true);
    setError(null);
    try {
      const { url } = await createCheckout(email);
      window.location.href = url;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Checkout failed');
      setLoading(false);
    }
  }

  return { checkout, loading, error };
}
